import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreCustomFormsHelpersSearchFiltersLabelsModule } from './labels/labels.module';
import { CoreCustomFormsHelpersSearchFiltersStatusModule } from './status/status.module';

import { PipesModule } from '@core/pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        CoreCustomFormsHelpersSearchFiltersLabelsModule,
        CoreCustomFormsHelpersSearchFiltersStatusModule,
        PipesModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
    ],
    exports: [
        CoreCustomFormsHelpersSearchFiltersLabelsModule,
        CoreCustomFormsHelpersSearchFiltersStatusModule,
    ],

})
export class CoreCustomFormsHelpersSearchFiltersModule { }